<script setup lang="ts">
defineProps({
  price: {
    type: Number,
    required: false,
    default: null,
  },
  text: {
    type: String,
    required: true,
  },
  craftingRequirements: {
    type: Object as PropType<CraftIngredient[]>,
    required: true,
  },
  showRequirements: {
    type: [Boolean, null] as PropType<boolean | null>,
    required: false,
    default: null,
  },
});
</script>

<template>
  <div class="py-5 px-7 sm:pr-0 border-b-2 border-primary-900">
    <div class="flex flex-col bg-neutral-800 shadow-xs">
      <p class="text-neutral-200 text-xs font-semibold pb-2">{{ text }}</p>
      <CardCraftList
        :craftingRequirements="craftingRequirements"
        :show-requirements="showRequirements"
        :detail-view="true"
        :is-link="true" />
    </div>
  </div>
</template>
